import React, { useState, useEffect } from 'react';
import { api } from '../api/client';

const TIER_COLORS = {
  light: '#a0aec0',
  medium: '#ecc94b',
  heavy: '#805ad5',
  ultra: '#ed8936',
};

export default function AchievementAdminPanel() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/achievements/admin/summary')
      .then(setData)
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading || !data) return null;

  return (
    <div className="card">
      <h3 style={{ marginBottom: 12 }}>Achievement Stats ({data.month})</h3>

      {/* Summary cards */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 16 }}>
        <div style={{
          padding: '14px', borderRadius: 'var(--radius-sm)',
          background: 'rgba(72,187,120,0.1)', border: '1px solid rgba(72,187,120,0.3)',
          textAlign: 'center',
        }}>
          <div style={{ fontSize: 28, fontWeight: 700, color: 'var(--success)' }}>{data.total_completed}</div>
          <div style={{ fontSize: 12, color: 'var(--text-muted)' }}>Completed This Month</div>
        </div>
        <div style={{
          padding: '14px', borderRadius: 'var(--radius-sm)',
          background: 'rgba(236,201,75,0.1)', border: '1px solid rgba(236,201,75,0.3)',
          textAlign: 'center',
        }}>
          <div style={{ fontSize: 28, fontWeight: 700, color: 'var(--warning)' }}>{data.spins_awarded}</div>
          <div style={{ fontSize: 12, color: 'var(--text-muted)' }}>Spins Awarded</div>
        </div>
      </div>

      {/* Two-column layout for leaderboard + popular */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 14 }}>
        {/* Top achievers */}
        <div>
          <h4 style={{ fontSize: 13, marginBottom: 8, color: 'var(--text-secondary)' }}>Top Achievers</h4>
          {data.top_achievers.length === 0 ? (
            <div style={{ fontSize: 12, color: 'var(--text-muted)', padding: 8 }}>No completions yet</div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
              {data.top_achievers.map((u, i) => (
                <div key={u.username} style={{
                  display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                  padding: '6px 10px', background: 'var(--bg-secondary)',
                  borderRadius: 'var(--radius-sm)', fontSize: 13,
                }}>
                  <span>
                    <span style={{ color: 'var(--text-muted)', marginRight: 6 }}>#{i + 1}</span>
                    <strong>{u.username}</strong>
                  </span>
                  <span style={{ color: 'var(--success)', fontWeight: 600 }}>{u.completed_count}</span>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Most completed achievements */}
        <div>
          <h4 style={{ fontSize: 13, marginBottom: 8, color: 'var(--text-secondary)' }}>Most Popular</h4>
          {data.popular_achievements.length === 0 ? (
            <div style={{ fontSize: 12, color: 'var(--text-muted)', padding: 8 }}>No completions yet</div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
              {data.popular_achievements.map(a => (
                <div key={a.title} style={{
                  display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                  padding: '6px 10px', background: 'var(--bg-secondary)',
                  borderRadius: 'var(--radius-sm)', fontSize: 13,
                }}>
                  <span>
                    <span style={{ marginRight: 6 }}>{a.icon}</span>
                    {a.title}
                    <span style={{ marginLeft: 6, color: TIER_COLORS[a.tier] || '#888', fontSize: 10 }}>
                      ({a.tier})
                    </span>
                  </span>
                  <span style={{ color: 'var(--accent)', fontWeight: 600 }}>{a.completions}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
